/**
 * 全站共享常量
 */

/** 品牌信息 */
export const BRAND = {
  nameZh: '观微',
  nameEn: 'FateLens',
  fullZh: '观微 · FateLens',
  tagline: '观天地之微，察人事之要',
  description: 'AI 命理咨询平台 —— 不算命，算战略',
} as const;

/** 主题模式存储 key */
export const THEME_STORAGE_KEY = 'guanwei.theme';

/** API 统一前缀 */
export const API_PREFIX = '/api/v1';

/** 法律页脚必出条款（阶段 0 即固定） */
export const LEGAL_DISCLAIMER =
  '本平台所有内容仅供文化娱乐与自我反思参考，不构成医疗、投资、法律或其他专业建议；不替代任何专业服务。';
